import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { apiErr, setToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in
  const [prefs, setPrefs] = useState(null);

  const loadPrefs = useCallback(async () => {
    try {
      const { data } = await client.get("/preferences");
      setPrefs(data || {});
    } catch { setPrefs({}); }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
      loadPrefs();
    } catch {
      setUser(false);
    }
  }, [loadPrefs]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password, remember = true) => {
    const { data } = await client.post("/auth/login", { email, password, remember });
    setToken(data.session_token, remember); setUser(data.user); loadPrefs(); return data.user;
  };
  const register = async (email, password, name) => {
    const { data } = await client.post("/auth/register", { email, password, name });
    setToken(data.session_token); setUser(data.user); loadPrefs(); return data.user;
  };
  const guest = async () => {
    const { data } = await client.post("/auth/guest", {});
    setToken(data.session_token); setUser(data.user); return data.user;
  };
  const logout = async () => {
    try { await client.post("/auth/logout", {}); } catch {}
    setToken(null); setUser(false); setPrefs(null);
  };
  const refresh = checkAuth;

  return (
    <AuthContext.Provider value={{ user, setUser, prefs, setPrefs, loadPrefs, login, register, guest, logout, refresh, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}
